// extracted by mini-css-extract-plugin
export default {"image":"AzureImageDisplay_image__XaOHL","imageRounded":"AzureImageDisplay_imageRounded__xLUz7 AzureImageDisplay_image__XaOHL"};